import { Badge } from "reactstrap";
import { DATE_FORMAT_VIEW } from "@src/utility/constants";
import Flex from "@components/ui-components/flex";
import LoadingButton from "@components/ui-components/loading-button";
import LongNameFormatter from "@components/formatters/long-name-formatter";
import capitalize from "lodash/capitalize";
import { getStatusBadge } from "@helpers/utils";
import useDateHandler from "@src/utility/hooks/use-date-handler";
import { useTranslation } from "react-i18next";

export const decoColumns = ({ handleLoginAsAdmin, handleRowActions }) => {
    const { t } = useTranslation();
    const { dateFormatter } = useDateHandler();

    return [
        {
            name    : "Name",
            selector: (row) => row.name,
            width   : "300px",
            cell    : (row) => (
                <LongNameFormatter
                    content={row.name}
                    className="fw-bold"
                    id={`name-${row._id}`}
                    max={35}/>
            )
        },
        {
            name    : "Admin Details",
            selector: (row) => row.admin?.name || "No Admin",
            width   : "287px",
            cell    : (row) => {
                const admin = row.admin;
                return admin ? (
                    <Flex column>
                        <p className="fw-bold mb-0">{capitalize(admin.name)}</p>
                        <p className="text-muted mb-0 small">{admin.email}</p>
                    </Flex>
                ) : (
                    <span className="text-muted">{t("No Admin")}</span>
                );
            }
        },

        {
            name    : "Status",
            selector: (row) => row.status,
            width   : "120px",
            cell    : (row) => (
                <Badge color={getStatusBadge(row.status)?.color}>
                    {t(getStatusBadge(row.status)?.title)}
                </Badge>
            )
        },
        {
            name    : "Created At",
            selector: (row) => row.created_at,
            width   : "250px",
            cell    : (row) => (
                <Flex>
                    <i className="mdi mdi-calendar me-1 font-medium-2" />
                    {dateFormatter({
                        date    : row?.created_at,
                        formatAs: DATE_FORMAT_VIEW
                    })}
                </Flex>
            )
        },
        {
            name : "Actions",
            width: "260px",
            cell : (row, index) => (
                <>
                    <LoadingButton
                        color="primary"
                        text="Login as Admin"
                        className="me-1"
                        disabled={!row.admin || row.status?.toLowerCase() === "inactive"}
                        onClick={() => handleLoginAsAdmin(row)}
                        testId={`login-admin-${row._id}`}/>
                    <LoadingButton
                        className="me-1"
                        outline
                        color="info"
                        id={`${row._id}-edit-button`}
                        testId={`${index}-edit-button`}
                        icon="pencil"
                        onClick={() => handleRowActions(row, "edit")}/>
                    <LoadingButton
                        outline
                        color="danger"
                        id={`${row._id}-edit-delete`}
                        testId={`${index}-delete-button`}
                        icon="delete"
                        onClick={() => handleRowActions(row, "delete")}/>
                </>
            )
        }
    ];
};
